<template>
  <div>
    <nav-bar/>
    <title-bar :title="$route.meta.title" style=" margin-bottom:30px;"/>
    <div class="echarts">
      <echart style="height: 210px;" :option="CweekTotalOption"/>
    </div>
    <div class="echarts">
      <echart style="height: 210px;" :option="ChistoryTotalOption"/>
    </div>
  </div>
</template>

<script>
import Echart from "@/components/echarts.vue";
import NavBar from "@/components/NavBar.vue";
import TitleBar from "@/components/TitleBar.vue";
import { statistics } from "@/api/userReq";
export default {
  components: {
    Echart,
    NavBar,
    TitleBar
  },

  data() {
    return {
      weekTotalOption: {},
      historyTotalOption: {}
    };
  },

  computed: {
    CweekTotalOption() {
      return this.weekTotalOption;
    },
    ChistoryTotalOption() {
      return this.historyTotalOption;
    }
  },

  created() {
    statistics().then(res => {
      this.weekTotalOption = {
        title: {
          text: "本周访问量"
        },
        xAxis: {
          type: "category",
          data: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"]
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            data: [
              res.weekViews["01"],
              res.weekViews["02"],
              res.weekViews["03"],
              res.weekViews["04"],
              res.weekViews["05"],
              res.weekViews["06"]
            ],
            type: "line",
            color: "#2d8cf0"
          }
        ]
      };
      this.historyTotalOption = {
        title: {
          text: "总访问量"
        },
        xAxis: {
          type: "category",
          data: [
            res.historyViews[0].endDate,
            res.historyViews[1].endDate,
            res.historyViews[2].endDate,
            res.historyViews[3].endDate,
            res.historyViews[4].endDate,
            res.historyViews[5].endDate
          ]
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            data: [
              res.historyViews[0].view,
              res.historyViews[1].view,
              res.historyViews[2].view,
              res.historyViews[3].view,
              res.historyViews[4].view,
              res.historyViews[5].view
            ],
            type: "line",
            color: "#2d8cf0"
          }
        ]
      };
    });
  }
};
</script>

<style scoped lang="less">
.echarts {
  background: rgba(255, 255, 255, 1);
  box-shadow: 1px 9px 23px 0px rgba(66, 83, 103, 0.15);
  border-radius: 4px;
  margin-bottom: 20px;
  width: 90%;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  padding-top: 10px;
}
</style>
